@if (isOpen() || isInline()) {
  @let bgImage = backgroundImage() ? 'url(' + backgroundImage() + ')' : null;
  @let canCloseOnBackdrop = hasCloseButton() || closeOnBackdrop();

  <div
    [class]="
      [
        'c-modal',
        sizeClass,
        typeClass,
        isOpen() ? 'is-open' : '',
        isInline() ? 'is-inline' : '',
        extraClassesString,
      ].join(' ')
    "
  >
    @if (!isInline()) {
      <div class="c-modal__backdrop" (click)="canCloseOnBackdrop && closeModal()"></div>
    }

    <div class="c-modal__container" [style.backgroundImage]="bgImage">
      @if (!isInline()) {
        <div class="c-modal__header">
          @if (modalHeader()) {
            <div class="c-modal__title">
              <ng-container *ngTemplateOutlet="modalHeader()" />
            </div>
          }
          @if (hasCloseButton()) {
            <div class="c-modal__btn" (click)="closeModal()">
              <bo-morph-button
                [state]="State.Close"
                [color]="type() === 'dark' ? Color.White : Color.NoColor"
              />
            </div>
          }
        </div>
      }

      <div class="c-modal__body">
        <ng-container *ngTemplateOutlet="modalBody()" />
      </div>

      @if (modalFooter() && !isInline()) {
        <div class="c-modal__footer">
          <ng-container *ngTemplateOutlet="modalFooter()" />
        </div>
      }
    </div>
  </div>
}
